import { combineReducers } from "redux";
import RouteMenuReducer from "VENDOR/Reducers/RouteMenuReducer";

const Reducers = combineReducers({
    RouteMenuReducer,
});

export default Reducers;